import { ItAssets, Pagination, Type } from '@core/interface/it_assets/itAssets';
import { createReducer, on } from '@ngrx/store';
import { ItAssetsActions } from './itassets.actions';

export const ItAssetsFeatureKey = 'ItAssets';

export interface ItAssetsState {
  ItAssets: ItAssets[];
  isLoading: boolean;
  isDeleted: boolean;
  loadError?: any;
  deleteError?: any;
  addEditError?: any;
  pagination: Pagination;
  types: Type[];
  assigningAsset?: boolean;
  deAssigningAsset?: boolean;
}

export const initialState: ItAssetsState = {
  ItAssets: [],
  isLoading: true,
  isDeleted: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
  types: [],
  assigningAsset: false,
  deAssigningAsset: false,
};

export const ItAssetsReducer = createReducer(
  initialState,
  on(ItAssetsActions.loadItAssets, (state) => ({ ...state, ItAssets: [] })),
  on(ItAssetsActions.loadItAssetsSuccess, (state, { data, pagination }) => ({
    ...state,
    pagination,
    ItAssets: data,
    isLoading: false,
    isDeleted: false,
    loadError: null,
  })),
  on(ItAssetsActions.loadItAssetsFailure, (state, { error }) => {
    return { ...state, loadError: error, isLoading: false, isDeleted: false };
  }),
  on(ItAssetsActions.addItAssetsSuccess, (state, { data }) => ({
    ...state,
    ItAssets: [...state.ItAssets, data],
    isDeleted: false,
    addEditError: null,
  })),
  on(ItAssetsActions.addItAssetsFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(ItAssetsActions.updateItAssetsSuccess, (state, { data }) => ({
    ...state,
    ItAssets: state.ItAssets.map((ItAssets) =>
      data.id == ItAssets.id ? data : ItAssets
    ),
    isDeleted: false,
    addEditError: null,
  })),
  on(ItAssetsActions.updateItAssetsFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(ItAssetsActions.deleteItAssetsSuccess, (state, { success, id }) => ({
    ...state,
    isDeleted: success,
    deleteError: null,
    ItAssets: state.ItAssets.filter((ItAssets) => ItAssets.id !== id),
  })),
  on(ItAssetsActions.deleteItAssetsFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: error,
  })),
  on(ItAssetsActions.deleteItAssets, (state) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(ItAssetsActions.loadItAssetsType, (state) => ({ ...state, types: [] })),
  on(ItAssetsActions.loadItAssetsTypeSuccess, (state, { data }) => ({
    ...state,
    types: data,
    isDeleted: false,
    loadTypeError: null,
  })),
  on(ItAssetsActions.loadItAssetsTypeFailure, (state, { error }) => {
    return {
      ...state,
      loadTypeError: error,
      isDeleted: false,
    };
  }),

  on(ItAssetsActions.addEditItAssetsTypeSuccess, (state, { data }) => ({
    ...state,
    types: [...state.types, data],
    isDeleted: false,
    addEditTypeError: null,
  })),
  on(ItAssetsActions.addEditItAssetsTypeFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    addEditTypeError: error,
  })),
  on(ItAssetsActions.updateItAssetsTypeSuccess, (state, { data }) => ({
    ...state,
    type: state.ItAssets.map((type) => (data.id == type.id ? data : type)),
    isDeleted: false,
    addEditTypeError: null,
  })),
  on(ItAssetsActions.updateItAssetsTypeFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditTypeError: error,
  })),
  on(ItAssetsActions.deleteItAssetsTypeSuccess, (state, { success, id }) => ({
    ...state,
    isDeleted: success,
    deleteTypeError: null,
    types: state.types.filter((type) => type.id !== id),
  })),
  on(ItAssetsActions.deleteItAssetsTypeFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteTypeError: error,
  })),
  on(ItAssetsActions.deleteItAssetsType, (state) => ({
    ...state,
    isDeleted: false,
    deleteTypeError: null,
  })),
  on(ItAssetsActions.resetDeleteStatus, (state) => ({
    ...state,
    isDeleted: false,
  })),
  on(ItAssetsActions.assignAsset, (state) => ({
    ...state,
    assigningAsset: true,
  })),
  on(ItAssetsActions.assignAssetSuccess, (state) => ({
    ...state,
    assigningAsset: false,
  })),
  on(ItAssetsActions.assignAssetFailure, (state) => ({
    ...state,
    assigningAsset: false,
  })),
  on(ItAssetsActions.deAssignAsset, (state) => ({
    ...state,
    deAssigningAsset: true,
  })),
  on(ItAssetsActions.deAssignAssetSuccess, (state) => ({
    ...state,
    deAssigningAsset: false,
  })),
  on(ItAssetsActions.deAssignAssetFailure, (state) => ({
    ...state,
    deAssigningAsset: false,
  }))
);
